// Presentation only: never apply to stored content, API payloads, or PDF exports.
export const analysisDisplayText = (text) => typeof text === 'string'
  ? text.replace(/\breports?\b/gi, 'Analysis')
  : text;
